export default __webpack_public_path__ + "static/media/photo-5@2x.6457ad10.png";